import { Pipe, PipeTransform } from '@angular/core';

import { convertProviderType } from '@kr/core';

@Pipe({
  name: 'providerType',
  standalone: true,
})
export class ProviderTypePipe implements PipeTransform {
  transform(value: string): string {
    return convertProviderType(value);
  }
}
